import styles from './Available.module.scss';
import React from 'react';
import { Button, Heading, Link } from '@wienenergiegithub/ui-next';
import AvailabilityAnswerRAG from '../../../Availability/AvailabilityComponents/AvailabilityAnswers/AvailabilityAnswerRAG/AvailabilityAnswerRAG';
import { getAddress } from '../../HeatRecommender.config';

// Renders the "available" Fernwaerme state for heat and general product recommenders
const Available = ({ signUpLink, orderLink, onNewCheck, storage }) => {
  // Set search params for fernwaerme Sign Up URL
  const signUpUrl = React.useMemo(() => {
    const url = new URL(signUpLink?.url);
    url.searchParams.set('tarifKey', 'waerme');
    url.searchParams.set('newAddress', storage?.currentAddress);
    return url.toString();
  }, [signUpLink?.url, storage?.currentAddress]);

  const isFernwaermeAvailable = storage?.Fernwaerme === 'JA';

  return (
    <div className={styles.container} data-purpose="fernwaerme-available">
      <AvailabilityAnswerRAG
        address={getAddress(storage)}
        heading="Fernwärme ist verfügbar!"
        icon="circle-check"
        iconColor="green"
      >
        <Heading as="p" className={styles.iWantHeading} size="h5">
          Ich möchte …
        </Heading>
        {isFernwaermeAvailable && (
          <Button
            className={styles.availableButton}
            id="available-fernwaerme-anmelden"
            render={<Link to={signUpUrl}>Fernwärme anmelden</Link>}
            theme="primary"
          />
        )}
        {!!orderLink?.url && (
          <Button
            className={styles.availableButton}
            id="available-fernwaerme-nachinstallieren"
            render={<Link to={orderLink.url}>Fernwärme nachinstallieren</Link>}
            theme="secondary"
          />
        )}
        <Button
          className={styles.newCheckButton}
          id="available-fernwaerme-weitere-addresse-pruefen"
          render={<Button onClick={onNewCheck}> Weitere Adresse prüfen</Button>}
          theme="secondary"
          variant="link"
        />
      </AvailabilityAnswerRAG>
    </div>
  );
};

export default Available;
